import init from "svelte-pixel-editor-wasm";

(window as any).js_console_log = (line: string) => console.log(line);

const noEventBinding = (name: string) => (event: string, data: any) =>
    console.error(`Failed to set WASM event bindings for ${name}::${event} (${data})`);
const noInstanceEventBinding = (name: string) => (instance: number, event: string, data: any) =>
    console.error(`Failed to set WASM event bindings for ${name}::${instance}::${event} (${data})`);

export const wasm_event_callback = ((window as any).wasm_event_callback = {
    interaction: noEventBinding("interaction"),
    file: noInstanceEventBinding("file"),
});

export const wasmPromise = init();
export let wasm = null! as Awaited<typeof wasmPromise>;

wasmPromise.then(($wasm) => {
    wasm = $wasm;
    wasm.enable_logging(4);
    (window as any).change_logging_level = wasm.change_logging_level.bind(wasm);
    console.log("WASM loaded");
});
